import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SubPageHeading from '../../../../organisms/SubPageHeading';
import { subPageNavEdit, subPageNavNew } from './AddressContainer.constants';

const AddressContainer = () => {
  const { state } = useLocation();

  const { name, navPage, subNav, state: defaultState } = state;

  const subPageNavEditExtended = subPageNavEdit.map((item) => ({
    ...item,
    state,
  }));

  return (
    <>
      <SubPageHeading
        subPageNav={name ? subPageNavEditExtended : subPageNavNew}
        subPageHeading={name || 'New Address'}
        name={name}
        nav={{
          to: '/db/datahandling/addresses',
          state: {
            navPage,
            subNav,
            state: defaultState,
          },
        }}
      />
      <Outlet />
    </>
  );
};

export default AddressContainer;
